export const relatorio = {
    methods: {

        async emailRelatorio () {

         const keys = [
             "patrimonio",
             "sucessao",
             "obrigacoes",
             "padrao",
             "educacaofilhos",
             "fonte_renda",
             "resumo_protecao",
             "projetos_futuros",
             "liberdade_financeira",
             "resumo_investimentos",
             "responsabilidade_civil",
             "incentivo_fiscal",
             "perfil_investidor"
        ];


        const first = keys.find(key => !!this.$refs[key])

        if (first) {
            this.$refs[first].$data.titulo = 'Introdução'
        }



          if(this.$refs.patrimonio) {
            this.patrimonio = await this.$refs.patrimonio.plot()
          }else{
            this.patrimonio = null
          }
          if(this.$refs.sucessao && this.$refs.sucessao){
            this.sucessao = await this.$refs.sucessao.plot();
          }else{
            this.sucessao = null
          }
          if(this.$refs.obrigacoes && this.$refs.obrigacoes.db.length > 0){
            this.obrigacoes = await this.$refs.obrigacoes.plot();
          }else{
            this.obrigacoes = null
          }
          if(this.$refs.padrao){
            this.padrao = await this.$refs.padrao.plot();
          }else{
            this.padrao = null
          }
          if(this.$refs.educacaofilhos && this.$refs.educacaofilhos.db.length > 0){
            this.educacaofilhos = await this.$refs.educacaofilhos.plot();
          }else{
            this.educacaofilhos = null
          }
          if(this.$refs.fonte_renda && this.$refs.fonte_renda.db.length > 0){
            this.fonte_renda = await this.$refs.fonte_renda.plot();
          }else{
            this.fonte_renda = null
          }
          if(this.$refs.resumo_protecao){
            this.resumo_protecao = await this.$refs.resumo_protecao.plot();
          }else{
            this.resumo_protecao = null
          }
          if(this.$refs.projetos_futuros){
            this.projetos_futuros = await this.$refs.projetos_futuros.plot();
          }else{
            this.projetos_futuros = null
          }
          if(this.$refs.liberdade_financeira){
            this.liberdade_financeira = await this.$refs.liberdade_financeira.plot();
          }else{
            this.liberdade_financeira = null
          }
          if(this.$refs.resumo_investimentos){
            this.resumo_investimentos = await this.$refs.resumo_investimentos.plot();
          }else{
            this.resumo_investimentos = null
          }
          if(this.$refs.responsabilidade_civil){
            this.responsabilidade_civil = await this.$refs.responsabilidade_civil.plot()
          }else {
            this.responsabilidade_civil = null
          }
          if(this.$refs.texto_final){
            this.texto_final = await this.$refs.texto_final.plot();
          }else{
            this.texto_final = null
          }

          const page = document.createElement('section')
          page.dataset.page = true;

          page.innerHTML += '<style>@media print and (color) { * {-webkit-print-color-adjust: exact;print-color-adjust: exact;}}</style>'

          if(this.$refs.patrimonio){
            page.innerHTML += '<div>'
            page.innerHTML += this.patrimonio
            page.innerHTML += '</div>'
          }
          if(this.$refs.sucessao && this.$refs.sucessao){
            page.innerHTML += '<div>'
            page.innerHTML += this.sucessao
            page.innerHTML += '</div>'
          }
          if(this.$refs.obrigacoes && this.$refs.obrigacoes.db.length > 0){
            page.innerHTML += '<div>'
            page.innerHTML += this.obrigacoes
            page.innerHTML += '</div>'
          }
          if(this.$refs.padrao){
            page.innerHTML += '<div>'
            page.innerHTML += this.padrao
            page.innerHTML += '</div>'
          }
          if(this.$refs.educacaofilhos && this.$refs.educacaofilhos.db.length > 0){
            page.innerHTML += '<div>'
            page.innerHTML += this.educacaofilhos
            page.innerHTML += '</div>'
          }
          if(this.$refs.fonte_renda && this.$refs.fonte_renda.db.length > 0){
            page.innerHTML += '<div>'
            page.innerHTML += this.fonte_renda
            page.innerHTML += '</div>'
          }

          let footer_resumo = false;

          if(this.$refs.resumo_protecao){

            footer_resumo  = true;
            page.innerHTML += '<div>';
            page.innerHTML += this.resumo_protecao
            page.innerHTML += '</div>'
          }

          if (this.$refs.projetos_futuros){

            page.innerHTML += '<div>';
            page.innerHTML += this.projetos_futuros
            page.innerHTML += '</div>'
          }


          let footer_aposentadoria = false;

          if(this.$refs.liberdade_financeira){

            footer_aposentadoria = true;

            page.innerHTML += '<div>';
            page.innerHTML += this.liberdade_financeira;
            page.innerHTML += '</div>';
          }

          if(this.$refs.resumo_investimentos){

            page.innerHTML += footer_aposentadoria ? '<div>' : '<div style="page-break-before: always"><div class="footer_logo"></div>';
            page.innerHTML += this.resumo_investimentos
            page.innerHTML += '</div>'
          }

          if(this.$refs.responsabilidade_civil) {
            page.innerHTML += '<div>'
            page.innerHTML += this.responsabilidade_civil
            page.innerHTML += '</div>'
          }

          if (this.$refs.incentivo_fiscal) {
            page.innerHTML += this.$refs.incentivo_fiscal.plot();
          }

          if (this.$refs.perfil_investidor) {
            page.innerHTML += this.$refs.perfil_investidor.plot();
          }


          if(this.$refs.texto_final){
            page.innerHTML += '<div>'
            page.innerHTML += this.texto_final
            page.innerHTML += '</div>'
          }

          return page.outerHTML
        },

    }
}



// WEBPACK FOOTER //
// ./src/components/relatorios/mixins/relatorio.js